export default "__VITE_ASSET__C3EK823F__"